// extracted by mini-css-extract-plugin
export default {"business_name":"businessName_business_name__EaCNy"};